<template>
<router-link :to="routerLink">
    <div class="c-process-teaser t-background-white-grey">
        
        <div class="c-process-teaser__content">
            <div>
				<can i="customize" a="ProcessTemplate">
					<span v-if="processType === 'ProcessTemplate'" class="c-process-teaser-content__custom t-text-style-zeta">Processmall</span>
				</can>
				<span class="c-process-teaser__status t-text-style-zeta" v-if="status === 'Unpublished'">
					<vue-icon name="closed-eye"></vue-icon>
					<span class="c-process-teaser-status__text">Ej publicerad</span>
				</span>
				<div class="c-process-teaser__text-content">
					<div :class="{'c-process-teaser__overlay' : this.status === 'Unpublished' || !$can('manage', 'ProcessTemplate') && processType === 'ProcessTemplate'}"></div>
                	<p>
						<h3 class="t-text-style-gamma">{{name}}</h3>
						<notify-pill v-if="notifications.length > 0 && $can('manage', 'Process')" :notifications="notifications"></notify-pill>
					</p>
                	<p class="t-text-style-epsilon">{{strippedString.substring(0,100)}}<span v-if="strippedString.length > 100">...</span></p>
				</div>
            </div>
            <vue-icon class="t-margin-left-s" name="arrow-right"></vue-icon>
        </div>
    </div>
</router-link>
</template>

<script>
import VueIcon from '@/components/vue-components/vue-icon/VueIcon.vue';
import NotifyPill from '@/components/vue-components/notify-pill/NotifyPill.vue'
import {
    mapGetters
} from 'vuex';
export default {
    name: 'ProcessTeaser',
    components: {
		VueIcon,
		NotifyPill
    },
    props: {
        id: String,
        name: String,
        description: String,
        status: String,
        processType: String,
		notifications: Array,
    },
    data() {
        return {
            routerLink: '/process/' + this.id,
            strippedString: this.description.replace(/(<([^>]+)>)/ig, " "),
        }
    },
}
</script>
